<template>
    <div class="product_difference container-fluid" v-loading="loader">
        <div class="row">
            <div class="col-md-6 border-right">
                <product-synthese-display title="Données PIM" typeDatas="pim" :categoriesOptions="categoriesOptions" :brandsOptions="brandsOptions" :product="product" :compare="speedwayDatas"></product-synthese-display>
            </div>
            <div class="col-md-6">
                <product-synthese-display title="Données Speedway"  typeDatas="prestashop" :categoriesOptions="categoriesOptions" :brandsOptions="brandsOptions" :product="speedwayDatas" :compare="product"></product-synthese-display>
            </div>
        </div>
    </div>
</template>
<script>
export default {
    data() {
        return {
            loader: false,
            brandsOptions: [],
            categoriesOptions: [],
            editor: {
                options: {}
            },
            speedwayDatas: {
                shop_id: null,
                reapro_type: null,
                vehicule: null,
                status: null,
                brand_id: null
            },
        };
    },
    props: {
        product: {
            required: 'required'
        }
    },
    computed: {
        productId() {
            return this.product.id
        }
    },
    watch: {
        productId(newV, oldV) {
            if (!newV) return;
            this.refresh();
        }
    },
    mounted() {
        this.loader = true
        axios.get('/brands').then(r => {
            this.brandsOptions = r.data.data;
        });
        axios.get('/categories').then(r => {
            this.categoriesOptions = r.data.data;
        });
        this.refresh()
    },

    methods: {
        refresh()
        {
            this.loader = true
            axios.get('/products/'+this.product.id+'/shop-view').then(r => {

                if( Object.values(r.data.data).length ) {
                    this.speedwayDatas = r.data.data
                } else {
                    this.speedwayDatas = {
                        shop_id: null,
                        reapro_type: null,
                        vehicule: null,
                        status: null,
                        brand_id: null
                    }
                }
                this.loader = false
            })
        }
    }
};
</script>
<style lang="scss">
</style>
